<template>
  <div class="oreder-modal">
    <el-dialog
      :close-on-click-modal="false"
      title="Delete"
      :visible="visible"
      width="728px"
      :before-close="handleClose"
    >
      <div class="oreder-modal-wrap">
        <p class="title">Sure to delete the payment method below?</p>

        <div class="payment-box">
          <div class="imgbox">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-Pay_Visa"></use>
            </svg>
          </div>
          <div class="payment-card">
            <p>Visa Card</p>
            <ul>
              <li>532 748 326 7238 842</li>
              <li>Expires</li>
              <li>06/26</li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" @click="visible = false">Delete</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
      },
    },
  },
  props: {},
  methods: {
    handleClose() {
      this.visible = false;
    },
    showChange() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-size: 14px;
  font-weight: 500;
  color: #0f1e33;
  line-height: 14px;
  margin-bottom: 32px;
}
.payment-box {
  width: 100%;
  padding: 24px;
  border: 1px solid #dbe1e8;
  display: flex;
  align-items: center;
  .imgbox {
    width: 80px;
    height: 50px;
    margin-right: 18px;
    background: linear-gradient(180deg, #ffffff 0%, #efefef 100%);
    border: 1px solid #cccccc;
    text-align: center;
    .icon {
      display: inline-block;
      width: 70px;
      height: 50px;
    }
  }

  .payment-card {
    flex: 1;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p {
      font-size: 16px;
      color: #2d3037;
    }
    ul {
      display: flex;
      justify-content: space-between;
      li {
        color: #0f1e33;
        font-size: 14px;
      }
      .orange {
        color: #f7ba2a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/DeleteCard.vue